/**
 * Form validation module
 */

export function setupFormValidation() {
    const inputs = document.querySelectorAll('input[required]');
    inputs.forEach(input => {
        input.addEventListener('blur', validateOnBlur);
        input.addEventListener('input', clearFieldError);
    });
}

// On blur we only surface problems with a value the user actually entered (format /
// min-length). An empty required field is NOT flagged here — that would nag the moment
// you tab away or dismiss the mobile keyboard on an untouched field. Emptiness is still
// enforced at submit (native `required` + the submit-time validateField loop).
function validateOnBlur(event) {
    if (!event.target.value.trim()) {
        clearFieldError(event);
        return;
    }
    validateField(event);
}

export function validateField(event) {
    const field = event.target;
    const value = field.value.trim();

    clearFieldError(event);

    let isValid = true;
    let errorMessage = '';

    // Get translated messages from data attributes or use defaults
    const messages = {
        required: field.dataset.msgRequired || 'This field is required',
        email: field.dataset.msgEmail || 'Please enter a valid email address',
        usernameMin: field.dataset.msgUsernameMin || 'Username must be at least 3 characters',
        passwordMin: field.dataset.msgPasswordMin || 'Password must be at least 6 characters'
    };

    if (!value) {
        isValid = false;
        errorMessage = messages.required;
    } else if (field.type === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
            isValid = false;
            errorMessage = messages.email;
        }
    } else if (field.name === 'username') {
        if (value.length < 3) {
            isValid = false;
            errorMessage = messages.usernameMin;
        }
    } else if (field.name === 'password' && field.autocomplete !== 'current-password') {
        if (value.length < 6) {
            isValid = false;
            errorMessage = messages.passwordMin;
        }
    }

    if (!isValid) {
        showFieldError(field, errorMessage);
    }

    return isValid;
}

export function clearFieldError(event) {
    const field = event.target;
    field.classList.remove('error');
    const formGroup = field.closest('.form-group') || field.parentNode;
    const errorElement = formGroup.querySelector('.field-error');
    if (errorElement) {
        errorElement.remove();
    }
}

export function showFieldError(field, message) {
    field.classList.add('error');

    // Find the form-group container (parent of input-group)
    const formGroup = field.closest('.form-group') || field.parentNode;

    const existingError = formGroup.querySelector('.field-error');
    if (existingError) {
        existingError.remove();
    }

    const errorElement = document.createElement('div');
    errorElement.className = 'field-error';
    errorElement.textContent = message;
    errorElement.style.color = '#dc3545';
    errorElement.style.fontSize = '12px';
    errorElement.style.marginTop = '4px';

    formGroup.appendChild(errorElement);
}
